const config = {
  baseUrlDevLocal: 'http://sjjc.sxzj.net:25600', // 开发本地
  baseUrlDevOnline: 'http://sjjc.sxzj.net:25600', // 开发线上测试
  baseUrlPro: 'http://sjjc.sxzj.net:25600', // 发布正式
  wsUrl: `sjjc.sxzj.net:25600`,
  SYSTEM_TITLE: '金玉其质 · 建瓴高屋',
  JIE_GOU_NAME: '登录主界面引导',
  XI_TONG_BM: '初始化平台',
  REGION: 'bj' // 客服地址 bj宝鸡  ak安康
}


config.baseUrl = process.env.NODE_ENV === 'production' ? config.baseUrlPro : config.baseUrlDevOnline;
module.exports = config